import store from '@/store/'

/**
 * アプリ内URL
 * @class Url
 */
export default class Url {
  /**
   * @constructor
   * @param {object} url メニューURLオブジェクト
   */
  constructor(url) {
    /** @type {boolean} */
    this.external = url.external

    /** @type {string} */
    this.path = this._makePath(url)

    /** @type {string} */
    this.function_code = url.href.function_code
  }

  /**
   * URLパスを生成する
   * @param {object} url メニューURLオブジェクト
   * @returns {string}
   */
  _makePath(url) {
    if (url.external) {
      return url.href.url
    }

    const { function_code: code, static_page_id: id } = url.href

    const path = code === 'static' ? `/${code}/${id}` : `/${code}`

    const businessId = store.getters['auth/businessId']
    const isStaff = store.getters['auth/isStaff']

    if (!isStaff || !businessId) {
      return path
    }

    return `/${businessId}${path}`
  }
}
